import { Pipe, PipeTransform } from '@angular/core';
import { humanizeEnumValue } from '../utils/enum-display';

@Pipe({
  name: 'titleCaseReplace',
})
export class TitleCaseReplacePipe implements PipeTransform {
  transform(value: string): string {
    return humanizeEnumValue(value);
  }
}
